const initialState = {};

export default (state = initialState, action) => {
    switch (action.type) {
        case 'CORE_UI:FETCH_TYPES_SUCCESS': {
            return {
                ...state,
                types: {
                    ...state.types,
                    ...action.data,
                },
            };
        }

        case 'CORE_UI:FETCH_SEARCH_TYPES_SUCCESS': {
            return {
                ...state,
                types: {
                    ...state.types,
                    search: action.data,
                },
            };
        }

        case 'CORE_UI:FETCH_TIMEZONE_SUCCESS': {
            return {
                ...state,
                types: action.data,
            };
        }

        case 'CORE_UI:FETCH_UTRRANGE_TYPES_SUCCESS': {
            return {
                ...state,
                types: {
                    ...state.types,
                    utrRange: action.data,
                },
            };
        }
        case 'CORE_UI:FETCH_PICKLEBALL_RATING_TYPES_SUCCESS': {
            return {
                ...state,
                types: {
                    ...state.types,
                    pickleballRating: action.data,
                },
            };
        }

        default:
            return state;
    }
};
